import { Button } from '@/components/button/Button'
import { isHeldByAnotherUser } from '@/editing-leases/utils/is-held-by-another-user'
import { useTimelineEditingLease } from '../hooks/useTimelineEditingLease'

export default function TimelineStartEditingButton() {
  const lease = useTimelineEditingLease()
  if (lease.initializing || lease.canWrite || !lease.enabled || isHeldByAnotherUser(lease.lease)) return null
  return (
    <Button size="sm" variant="tonal" color="primary" onClick={lease.startEditing} loading={lease.pending}>
      Start editing
    </Button>
  )
}
